import React, { useState, useEffect } from "react";
import { DataEntryField } from "./DataEntryField";
import { UnitOfMeasureControl } from "../controls/UnitOfMeasureControl";
import {
  DistanceControl,
  DistanceFieldChangeResult
} from "../controls/DistanceControl";
import { TimeControl, TimeFieldChangeResult } from "../controls/TimeControl";
import { UnitOfMeasure, Pace } from "../../pace-fns/pace-fns";
import {isPaceValid} from "../../calculator.utility";
type Props = {
  pace: Pace;
  onChange(isValid: boolean, distance?: Pace): void;
  selectField: () => void;
  isCalculable: boolean;
};

export const PaceEntryField = ({
  pace,
  selectField,
  isCalculable,
  onChange
}: Props) => {
  const [paceState, setPaceState] = useState(pace);

  useEffect(() => {
    setPaceState(pace);
  }, [pace]);

  const onUnitOfMeasureControlChange = (unitOfMeasure: UnitOfMeasure) => {
    const updatedPace: Pace = {
      ...paceState,
      distance: { ...paceState?.distance, unitOfMeasure }
    };
    setPaceState(updatedPace);
    onChange(isPaceValid(updatedPace), updatedPace);
  };

  const onDistanceControlChange = (changeResult: DistanceFieldChangeResult) => {
    const updatedPace: Pace = {
      ...paceState,
      distance: changeResult.data.value!
    };
    setPaceState(updatedPace);
    onChange(changeResult.valid, updatedPace);
  };

  const onTimeChange = (changeResult: TimeFieldChangeResult) => {
    const updatedPace: Pace = {
      ...paceState,
      time: changeResult.data.value!
    };
    setPaceState(updatedPace);
    onChange(changeResult.valid, updatedPace);
  };

  const TimeEntryField = (
    <TimeControl
      onTimeChange={onTimeChange}
      time={pace.time}
    ></TimeControl>
  );

  const DistanceEntryField = (
    <DistanceControl
      onChange={onDistanceControlChange}
      distance={paceState.distance}
    ></DistanceControl>
  );

  const UnitOfMeasureEntryField = (
    <UnitOfMeasureControl
      onChange={onUnitOfMeasureControlChange}
      value={paceState.distance?.unitOfMeasure || UnitOfMeasure.METER}
    />
  );

  return (
    <DataEntryField
      fields={[TimeEntryField, DistanceEntryField, UnitOfMeasureEntryField]}
      isCalculable={isCalculable}
      onSelect={selectField}
    ></DataEntryField>
  );
};
